import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'

import { ToastContainer, toast } from 'react-toastify';

const TecSTechnologyMain = () => {

  useEffect(()=>{

    document.getElementById('tec-sectionMain').style.display = "none";
    setTimeout(()=>{
    document.getElementById('tec-sectionMain').style.display = "block";
 
  },1000)
  },[])

  return (
    <div className='tec-addmain'>
      
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
         <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">TECNOLOGIES</span></span>
 <div className='tec-addmain-back'>
<Link to="/Tecsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div>
 </p> 

 {/* <hr></hr> */}
 </div>
    </div>    


    <ul id="tecLableSection">
  <li className="tecdot tecdottyTech1"id="tec-lableMainA"></li>

  
  </ul>
  <ul id='tec-sectionMain'>

<li className='tectitle1 tectitle-animate' id="tec-touchMainA"><Link to="/TecTechnology"> Technology</Link></li>




 </ul>
   
     <div>
    
  
        </div>
  


        </div>
  )
}

export default TecSTechnologyMain
